import { render, staticRenderFns } from "./ProcessDesign.vue?vue&type=template&id=5076c3ed&scoped=true"
import script from "./ProcessDesign.vue?vue&type=script&lang=js"
export * from "./ProcessDesign.vue?vue&type=script&lang=js"
import style0 from "./ProcessDesign.vue?vue&type=style&index=0&id=5076c3ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5076c3ed",
  null
  
)

export default component.exports